function HandlePageShow(event)
{
    var navEntry = performance.getEntriesByType("navigation")[0];

    var isBackNavigation =
    (
        (navEntry && navEntry.type === "back_forward") ||
        event.persisted === true
    );

    if (!isBackNavigation)
    {
        return;
    }

    console.log("Back navigation detected (Safari/Chrome) – refreshing cart drawer");
    RefreshCartDrawerAfterBackNavigation();
}

function RefreshCartDrawerAfterBackNavigation()
{
    fetch("/cart.js")
        .then(function(cartResponse)
        {
            return cartResponse.json();
        })
        .then(function(cartJson)
        {
            var map = {};
            if (Array.isArray(cartJson.items))
            {
                cartJson.items.forEach(function(item)
                {
                    map[String(item.variant_id)] = Number(item.quantity || 0);
                });
            }
            window.__BACKNAV_CART_MAP__ = map;

            setTimeout(function()
            {
                if (window.__BACKNAV_CART_MAP__ === map)
                {
                    window.__BACKNAV_CART_MAP__ = null;
                }
            }, 10000);

            return fetch("/?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template")
                .then(function(sectionResponse)
                {
                    return sectionResponse.json();
                })
                .then(function(sectionJson)
                {
                    var cartObject =
                    {
                        sections   : sectionJson,
                        item_count : cartJson.item_count
                    };

                    updateCartDrawer(cartObject);

                    if (typeof window.refreshProductCardButtons === "function")
                    {
                        window.refreshProductCardButtons();
                        setTimeout(function()
                        {
                            window.refreshProductCardButtons();
                        }, 500);
                    }
                });
        })
        .catch(function(error)
        {
            console.error("Back-nav cart refresh failed:", error);
        });
}

window.addEventListener("pageshow", function(event)
{
    var navEntry = performance.getEntriesByType("navigation")[0];

    var isBackNavigation =
    (
        (navEntry && navEntry.type === "back_forward") ||
        event.persisted === true
    );

    if (!isBackNavigation)
    {
        return;
    }

    setTimeout(function()
    {
        RefreshCartDrawerAfterBackNavigation();
    }, 50);
});
